function header() {
	const mainHeader = document.querySelector('header#main_header')
	const nav = mainHeader.querySelector('nav[data-main-nav]')
	const subnavs = nav.querySelectorAll('.subnav')
	const subnavsLinks = nav.querySelectorAll('[data-second-level-subnav]')
	const menuOverlay = document.getElementById('menu_overlay')
	const mobileMenuToggle = document.getElementById('mobile_menu_toggle')
	const searchToggle = document.querySelector('header .search button')
	
	const mainLinks = nav.querySelectorAll('ul > li > span')

	let expanded = false
	let menuExpanded = false
	let stuck = false
	let headerCollapsed = false
	let lastScrollY = window.scrollY
	let scrollDirection = 'down'

	window.addEventListener('scroll', () => {
		const currentScrollY = window.scrollY
		scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up'
		lastScrollY = currentScrollY

		if (window.scrollY > mainHeader.offsetHeight) {
			stick()
		} else if (window.scrollY == 0) {
			unstick()
		}

		if (stuck) {
			if (scrollDirection === 'down' && !headerCollapsed) {
				headerCollapsed = true
				mainHeader.style.transform = 'translateY(-100%)'
				mainHeader.style.boxShadow = '0'
				document.documentElement.style.setProperty('--header-height', '0')
			} else if (scrollDirection === 'up' && headerCollapsed) {
				headerCollapsed = false
				mainHeader.style.transform = 'translateY(0)'
				mainHeader.style.boxShadow = '0 1rem 0 #e6ebef'
				document.documentElement.style.setProperty('--header-height', `${mainHeader.offsetHeight}px`)
			}
		}
	})

	// Fix weird transition gap when resizing window
	let timeout = null
	window.addEventListener('resize', () => {
		mainHeader.style.transition = 'none'
		subnavs.forEach((subnav) => {
			subnav.style.transition = 'none'
		})
		clearTimeout(timeout)
		timeout = setTimeout(() => {
			mainHeader.style.transition = ''
			subnavs.forEach((subnav) => {
				subnav.style.transition = ''
			})
		}, 200)

		if (window.innerWidth > 800) {
			window.mobile = false
		} else {
			window.mobile = true
		}
	})

	window.mobile = false
	if (window.innerWidth < 800) {
		window.mobile = true
	}

	function stick() {
		if (!stuck) {
			stuck = true
			mainHeader.style.position = 'fixed'
			// Don't transition when first sticking.
			mainHeader.style.transition = 'none'
			document.body.style.paddingTop = `${mainHeader.offsetHeight}px`
			setTimeout(() => {
				mainHeader.style.transition = ''
			})
		}
	}

	function unstick() {
		if (stuck) {
			stuck = false
			mainHeader.style.position = ''
			document.body.style.paddingTop = ''
		}
	}

	function collapseOthers(link) {
		mainLinks.forEach((otherLink) => {
			if (otherLink !== link && otherLink.expanded) {
				collapseSubmenu(otherLink)
			}
		})
	}

	function expandSubmenu(link) {
		collapseOthers(link)

		const subnav = link.parentNode.querySelector('.subnav')

		if (!subnav) return

		const arrow = link.querySelector('svg')
		
		arrow.classList.add('rotate-180', 'opacity-100')
		link.classList.add('text-blue300')

		menuOverlay.classList.add('opacity-100')
		menuOverlay.classList.remove('pointer-events-none')

		expanded = true

		subnav.classList.add(
			'opacity-100',
		)
		subnav.style.setProperty('--tw-translate-y', '0')
		subnav.classList.add('pointer-events-auto')

		if (window.mobile) {
			arrow.classList.add('fill-white')
			link.classList.add('bg-blue300', 'text-white')

			let subnavHeight = 0
			subnav.querySelectorAll('[data-subnav-links] > div').forEach((link) => {
				subnavHeight += link.offsetHeight
			})
			subnav.style.height = `${subnavHeight}px`
		}
	}

	function collapseSubmenu(linkToCollapse) {
		if (!linkToCollapse) {
			mainLinks.forEach((link) => {
				if (link.expanded) {
					linkToCollapse = link
				}
			})
		}
		
		const subnav = linkToCollapse.parentNode.querySelector('.subnav')

		if (!subnav) return

		const arrow = linkToCollapse.querySelector('svg')
		
		arrow.classList.remove('rotate-180', 'opacity-100')
		linkToCollapse.classList.remove('text-blue300')
		
		linkToCollapse.expanded = false
		expanded = false
		
		menuOverlay.classList.remove('opacity-100')
		menuOverlay.classList.add('pointer-events-none')
		
		subnav.classList.remove(
			'opacity-100'
		)
		subnav.style.setProperty('--tw-translate-y', '')
		subnav.classList.remove('pointer-events-auto')

		if (window.mobile) {
			// Collapse deeper subnavs
			subnav.querySelectorAll('[data-second-level-subnav]').forEach((button) => {
				button.nextElementSibling.style.height = ''
			})

			arrow.classList.remove('fill-white')
			linkToCollapse.classList.remove('bg-blue300', 'text-white')
			subnav.style.height = `0`
		}
	}

	mainLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault()
			e.stopPropagation()

			link.expanded = !link.expanded

			if (link.expanded) {
				expandSubmenu(link)
			} else {
				collapseSubmenu(link)
			}
		})
	})

	subnavsLinks.forEach((button) => {
		button.expanded = false

		button.addEventListener('click', (e) => {
			e.preventDefault()
			e.stopPropagation()

			const clicked = e.target
			const linksWrapper = clicked.nextElementSibling
			clicked.expanded = !clicked.expanded
			if (clicked.expanded) {
				clicked.expanded = true
				let linksWrapperHeight = 0
				linksWrapper.querySelectorAll('a').forEach((link) => {
					linksWrapperHeight += link.offsetHeight
				})
				linksWrapper.style.height = `${linksWrapperHeight}px`
				subnavsLinks.forEach((otherButton) => {
					if (otherButton !== clicked && otherButton.expanded) {
						let otherButtonHeight = otherButton.nextElementSibling.offsetHeight
						otherButton.expanded = false
						otherButton.nextElementSibling.style.height = ''
						let parentSubnav = otherButton.closest('.subnav')

						setTimeout(() => {
							if (parentSubnav) {
								let parentSubnavHeight = parentSubnav.offsetHeight
								parentSubnav.style.height = `${parentSubnavHeight - otherButtonHeight + linksWrapperHeight}px`
							}
						}, 1)
					}
				})

				const parentSubnav = linksWrapper.closest('.subnav')
				if (parentSubnav) {
					const parentSubnavHeight = parentSubnav.offsetHeight
					parentSubnav.style.height = `${parentSubnavHeight + linksWrapperHeight}px`
				}
			} else {
				const linksWrapperHeight = linksWrapper.offsetHeight
				const parentSubnav = linksWrapper.closest('.subnav')
				if (parentSubnav) {
					const parentSubnavHeight = parentSubnav.offsetHeight
					parentSubnav.style.height = `${parentSubnavHeight - linksWrapperHeight}px`
				}
				
				linksWrapper.style.height = ''
			}
		})
	})

	searchToggle.addEventListener('click', (e) => {
		// Only prevent default for actual mouse clicks
		if (e.pointerType === 'mouse') {
			e.preventDefault()
			e.stopPropagation()
		}

		if (e.pointerType === 'touch') {
			e.preventDefault()
			e.stopPropagation()
			window.location.href = '/search'
			return
		}

		const search = document.querySelector('header .search')
		const inputWrapper = search.querySelector('.input_wrapper')
		const input = inputWrapper.querySelector('input')

		inputWrapper.open = !inputWrapper.open
		if (inputWrapper.open) {
			inputWrapper.style.width = '300px'
			input.style.opacity = 1
			input.focus()
			inputWrapper.querySelector('input').focus()
		} else {
			input.style.opacity = 0
			inputWrapper.style.width = ''
		}
	})

	mobileMenuToggle.addEventListener('click', () => {
		menuExpanded = !menuExpanded

		if (menuExpanded) {
			nav.style.setProperty('top', '0')
			mobileMenuToggle.querySelector('#hamburger').style.opacity = 0
			mobileMenuToggle.querySelector('#close_menu').style.opacity = 1
			document.documentElement.style.overflow = 'hidden'
			document.body.style.overflow = 'hidden'
		} else {
			nav.style.setProperty('top', '')
			mobileMenuToggle.querySelector('#hamburger').style.opacity = ''
			mobileMenuToggle.querySelector('#close_menu').style.opacity = ''
			document.documentElement.style.overflow = ''
			document.body.style.overflow = ''
		}
	})

	menuOverlay.addEventListener('click', () => {
		collapseSubmenu()
	})
}

header()